module.exports = __webpack_public_path__ + "static/img/gaojing.eacecae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gaojing.jpg
// module id = oOHW
// module chunks = 1